import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Route, Redirect } from 'react-router-dom';

class AuthRoute extends Component {
	render() {
		const { accessToken, accessIsForMobile, component: Component, ...rest } = this.props;
		return (
			<Route
				{...rest}
				render={function (props) {
					const { location } = props;

					if (accessIsForMobile) {
						return (
							<Redirect
								to={{
									pathname: '/mobile',
									state: {
										authError:
											'You only have access to sphere mobile. If you need non-mobile access please logout and then log back in.',
										from: location,
									},
								}}
							/>
						);
					}

					if (accessToken) {
						return <Component {...props} />;
					} else {
						return (
							<Redirect
								to={{
									pathname: '/login',
									state: { from: location },
								}}
							/>
						);
					}
				}}
			/>
		);
	}
}

AuthRoute.propTypes = {
	accessToken: PropTypes.string,
	accessIsForMobile: PropTypes.bool,
	component: PropTypes.object,
	location: PropTypes.object,
};

function mapStateToProps(state) {
	return { accessToken: state.auth.accessToken, accessIsForMobile: state.auth.accessIsForMobile };
}

export default connect(mapStateToProps)(AuthRoute);
//export default AuthRoute;
